import React, { useState, useEffect } from "react";
import { Icon } from "@culturehq/components";

import styles from "./timer.module.scss";

const Timer = ({ pause = false }) => {
  const [time, setTime] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    let interval = null;

    if (!isPaused) {
      interval = setInterval(() => {
        setTime(time => time + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isPaused]);

  useEffect(() => {
    setIsPaused(pause);
  }, [pause]);

  const formatTime = () => {
    const getSeconds = `0${(time % 60)}`.slice(-2);
    const minutes = `${Math.floor(time / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);

    return `${getMinutes}:${getSeconds}`;
  };

  return (
    <span className={styles.Timer}>
      <Icon icon="record" />
      {formatTime()}
    </span>
  );
};

export default Timer;
